import { useUserConfig } from "@/shared/domain/config/hooks";
import { getQueryKey } from "@/shared/domain/config/hooks/useUserConfig";

import type { ApprovalMode } from "../clientTools/approvalModes";

/** Maps tool spec name (e.g. "navigate", "create_events") to user's preferred approval mode. */
type ClientToolPreferences = Record<string, ApprovalMode>;

const CONFIG_KEY = "client_tool_preferences";

/**
 * Query key for client tool preferences, exported for use by the mutation hook.
 */
export function getClientToolPreferencesQueryKey() {
  return getQueryKey(CONFIG_KEY);
}

/**
 * Read client-tool approval preferences.
 *
 * Returns the full `UseQueryResult` so callers have access to `data`,
 * `isLoading`, `error`, `isFetching`, `refetch`, etc.
 *
 * Preferences are stored as a `Record<string, ApprovalMode>` under the
 * `"client_tool_preferences"` user config key. Tools not present in the
 * record use their `defaultApprovalMode`.
 */
export function useClientToolPreferences() {
  return useUserConfig<ClientToolPreferences>(CONFIG_KEY);
}
